import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import MaterialDashboard from "./material-dashboard";
import Multiselect from 'vue-multiselect';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap';
// import Swal from 'sweetalert2';
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import ToastService from 'primevue/toastservice';


// Import PrimeVue components
import 'primeicons/primeicons.css';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Toolbar from 'primevue/toolbar';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import Rating from 'primevue/rating';
import Tag from 'primevue/tag';
import FileUpload from 'primevue/fileupload';

const appInstance = createApp(App);

appInstance.component('DataTable', DataTable);
appInstance.component('Column', Column);
appInstance.component('Toolbar', Toolbar);
appInstance.component('Button', Button);
appInstance.component('InputText', InputText);
appInstance.component('IconField', IconField);
appInstance.component('InputIcon', InputIcon);
appInstance.component('Rating', Rating);
appInstance.component('Tag', Tag);
appInstance.component('FileUpload', FileUpload);

import { definePreset } from '@primevue/themes';
const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{yellow.50}',
            100: '{yellow.100}',
            200: '{yellow.200}',
            300: '{yellow.300}',
            400: '{yellow.400}',
            500: '{yellow.500}',
            600: '{yellow.600}',
            700: '{yellow.700}',
            800: '{yellow.800}',
            900: '{yellow.900}',
            950: '{yellow.950}'
        }
    },
});
appInstance.use(store);
appInstance.component('Multiselect', Multiselect);
appInstance.use(router);
appInstance.use(ToastService);
appInstance.use(PrimeVue, {
    theme: {
        preset: MyPreset,
    }
}); appInstance.use(MaterialDashboard);
appInstance.mount("#app");
